import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-all-auctions-tab',
  templateUrl: './salvage-all-auctions-tab.component.html',
})
export class SalvageAllAuctionsTabComponent {
  @Input() context!: SalvageTabContext;
}
